import React from 'react'
import styled from 'styled-components'
import {BoldSpan} from '../StyledSpan'
import {LabelDisplayedRowsArgs} from '@mui/material';
import {formatNumberWithCommas} from '../../formatters/formatNumberWithCommas'

interface Props {
    countUnit?: string
}

const ListTablePaginationDisplayedRows: React.FC<Props & LabelDisplayedRowsArgs> = props => {
    const countUnit: string = props.countUnit || '件'
    return (
        <IllegalMarginedDivForTablePagination>
            <BoldSpan>{formatNumberWithCommas(props.count)}</BoldSpan>{countUnit}
            （{formatNumberWithCommas(props.from)}〜{formatNumberWithCommas(props.to)}{countUnit}目を表示）
        </IllegalMarginedDivForTablePagination>
    )
}

ListTablePaginationDisplayedRows.displayName = 'ListTablePaginationDisplayedRows'
export default ListTablePaginationDisplayedRows

const IllegalMarginedDivForTablePagination = styled.span`
  position: absolute;
  left: 0;
  margin-top: -8px;
  margin-left: 10px;
`
